import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitSourceActivityVersion} from "./pit-source-activity-version";
import {PitFinancingRedistributionBySource} from "./pit-financing-redistribution-by-source";
import {IPitFinancingRedistributionLite, PitFinancingRedistributionLite} from "./pit-financing-redistribution-lite";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";
import {DxCoreUtils} from "../../dx-core/utiles/dx-core-utils";
import {PitBpmProcessInstance} from "../../pit-shared/domain/pit-bpm-process-instance";

/** Перераспределение финансирования между мероприятиями */

@jsonObject
export class PitFinancingRedistribution extends DxGridRow implements IPitFinancingRedistributionLite {

  /** Уникальный идентификатор перераспределения */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  _id: number;

  /** Версия мероприятия «донора» */
  @jsonMember({name: "sourceActivityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false })
  private _sourceActivityVersion: PitSourceActivityVersion = new PitSourceActivityVersion();

  /** Видимо версия текущего мероприятия (в карточке) */
  @jsonMember({name: "destinationActivityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false })
  private _destinationActivityVersion: PitSourceActivityVersion = new PitSourceActivityVersion();

  /** Массив строк перераспределения финансирования между мероприятиями по источникам */
  @jsonArrayMember(PitFinancingRedistributionBySource, {name: "financingRedistributionBySource", emitDefaultValue: false, preserveNull: false, isRequired: false})
  _financingRedistributionBySource: PitFinancingRedistributionBySource[] = [];

  /** Статус «транзакции» перераспределения финансирования. Ссылка на статусы объектов системы */
  @jsonMember({name: "statusId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _statusId: number;

  /** Уточненный статус согласования перераспределения. Ссылка на статусы бизнес-процесса */
  @jsonArrayMember(Number, {name: "status2Ids", emitDefaultValue: false, isRequired: false})
  private _status2Ids: number[];


  @jsonMember({name: "sourceActivityVersionId", constructor: Number, emitDefaultValue: false, isRequired: false })
  get sourceActivityVersionId(): number {
    return this.sourceActivityVersion ? this.sourceActivityVersion.id : null;
  }


  processInstance: PitBpmProcessInstance;
  isLoading: boolean;

  get isNew(): boolean {
    return this.id !== this._id;
  }

  private _fakeId = DxCoreUtils.randomHexaDecimal();

  get id(): any {
    return this._id ? this._id : this._fakeId;
  }

  set id(value: any) {
    this._id = value;
  }

  getRowId() {
    return this.id;
  }

  get sourceActivityVersion(): PitSourceActivityVersion {
    return this._sourceActivityVersion;
  }

  set sourceActivityVersion(value: PitSourceActivityVersion) {
    this._sourceActivityVersion = value;
  }

  get destinationActivityVersion(): PitSourceActivityVersion {
    return this._destinationActivityVersion;
  }

  set destinationActivityVersion(value: PitSourceActivityVersion) {
    this._destinationActivityVersion = value;
  }

  get statusId(): number {
    return this._statusId;
  }

  set statusId(value: number) {
    this._statusId = value;
  }

  get status2Ids(): number[] {
    return this._status2Ids;
  }

  set status2Ids(value: number[]) {
    this._status2Ids = value;
  }

  get financingRedistributionBySource(): PitFinancingRedistributionBySource[] {
    return this._financingRedistributionBySource;
  }

  set financingRedistributionBySource(value: PitFinancingRedistributionBySource[]) {
    this._financingRedistributionBySource = value;
  }

  constructor(fields?: Partial<PitFinancingRedistribution>) {
    super();
    if (fields) {
      Object.assign(this, fields);
    }
  }
}
